import { css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const cseSelectableGroup = {
  gap: css`var(--cse-selectable-group-gap, ${csSpacing.spacing05})`,
  gapInline: css`var(--cse-selectable-group-gap-inline, ${csSpacing.spacing05})`,
  gridTemplateRows: css`var(--cse-selectable-group-grid-template-rows, repeat(3, 1fr))`,
  gridTemplateColumns: css`var(--cse-selectable-group-grid-template-columns, repeat(4, 1fr))`,
  gridTemplateColumnsY: css`var(--cse-selectable-group-grid-template-columns-y, auto)`,
}

export const style = css`
  .cse-selectable-group {
    display: grid;
    gap: ${cseSelectableGroup.gap};
    grid-template-rows: ${cseSelectableGroup.gridTemplateRows};
    grid-template-columns: ${cseSelectableGroup.gridTemplateColumnsY};
    
    
    &.space-between {
      justify-content: space-between;
    }
    
    &.space-evenly {
      justify-content: space-evenly;
    }
    
    &.start {
      justify-content: start;
    }
    
    &.center {
      justify-content: center;
    }
    
    &.end {
      justify-content: end;
    }
  }

  .inline {
    gap: ${cseSelectableGroup.gapInline};
    grid-template-columns: ${cseSelectableGroup.gridTemplateColumns};
    grid-template-rows: auto;
  }
`
